import React from 'react';

interface MessageProps {
  title: string;
  description: string;
}

const Message: React.FC<MessageProps> = ({ title, description }) => {
  return (
    <div className="container mt-4">
      <div className="card shadow-sm">
        <div className="card-body">
          <h5 className="card-title">{title}</h5>
          <p className="card-text">{description}</p>
        </div>
      </div>
    </div>
  );
};

export default Message;
